import React, { Component } from 'react';
import queryString from 'query-string';
import { Form, Field } from 'react-final-form';
import { GlobalContext } from '../global-context';
import Styles from "../Styles.js";
import Checkbox from "../parts/checkbox.js";
import { needFlags } from '../util/flagcalc';
import { getFlagParams } from '../util/config';
import { ERRORSTYLE } from "../util/constants";

const minSigLength = 5

const sigRequired = (value) => {
    if (!value) {
        return "Required"
    }
    if (value.length < minSigLength) {
        return "Too short"
    }
    const spaces = value.match(/([\s])/g)
    if (spaces === null) {
        return undefined
    }
    if (value.length - spaces.length < minSigLength) {
        return "Too few characters"
    }
    return undefined
}

const verifyPerson = (verification, values) => {
  return new Promise ((resolve, reject) => {
    let endpoint = `/api/person/${verification.eppn}/verify`;
    let bodyObj = {
      signatures: [
        {
            label: verification.sigline,
            signature: values[verification.siglabel]
        }
      ],
      name: verification.flag
    }
    if (values[verification.datelabel] && values[verification.datelabel].length > 0){
      bodyObj.mseconds = Date.parse(values[verification.datelabel])/1000;
    }
    fetch(endpoint, {
        method: 'PUT',
        body: JSON.stringify(bodyObj),
        headers:{
            'Content-Type': 'application/json'
        }
    })
    .then((responseData) => {
      resolve();
    },
    (err) => {
      console.log(err);
      reject(err);
    });
  });
}

const verifyMember = (verification, values) => {
  return new Promise ((resolve, reject) => {
    let endpoint = `/api/project/${verification.project.id}/verify/${verification.eppn}`;
    let bodyObj = {
      signatures: [
        {
            label: verification.sigline,
            signature: values[verification.siglabel]
        }
      ],
      name: verification.flag
    }
    if (values[verification.datelabel] && values[verification.datelabel].length > 0){
      bodyObj.mseconds = Date.parse(values[verification.datelabel])/1000;
    }
    fetch(endpoint, {
        method: 'PUT',
        body: JSON.stringify(bodyObj),
        headers:{
            'Content-Type': 'application/json'
        }
    })
    .then((responseData) => {
      resolve();
    },
    (err) => {
      console.log(err);
      reject(err);
    });
  });
}

export default class VerifyContainer extends Component {
    static contextType = GlobalContext;

    constructor(props) {
        super(props);
        this.state = {
            project: null,
            projectID: null,
            verifications: [],
        };

        this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
    }

    componentDidMount() {
        const values = queryString.parse(this.props.location.search);
        const pid = values.project;
        fetch(`/api/project/${pid}`)
            .then(res => res.json())
            .then(proj => {
                this.setState({
                    project: proj,
                    projectID: pid
                });
            });
    }

    validDate = (value, _, meta) => {
      if (!value) {
        return "Required"
      }
      if (value.length < 6) {
        return "Invalid date"
      }
      const timestamp = Date.parse(value)
      if (isNaN(timestamp)) {
        return "Invalid date"
      }
      const now = Date.now()
      if (timestamp > now) {
        return "Invalid date - in the future"
      }
      const { name } = meta
      const { config } = this.context;
      const fname = name.split(":")[1]
      const fp = getFlagParams(config, fname)
      const { expire_days } = fp;
      const expiremilliseconds = expire_days*24*3600*1000;
      if (expiremilliseconds > 0 && timestamp + expiremilliseconds < now) {
        return "Invalid date - too old"
      }
      return undefined
    }

    handleCheckboxChange = (e, flag) => {
      let current = this.state[flag.label];
      let verifications = this.state.verifications;
      if (current === false || current === undefined) {
        verifications.push(flag);
      }
      else {
        verifications = verifications.filter(v => v.label !== flag.label);
      }
      this.setState({[flag.label]: !current, verifications: verifications });
    }

    onSubmit = async (values) => {
        let verificationRequests = [];
        const { navigate } = this.props;
        const { projectID, verifications } = this.state;
        verifications.forEach(v => {
          if (v.project) {
            verificationRequests.push(
              verifyMember(v, values)
            );
          } else {
            verificationRequests.push(
              verifyPerson(v, values)
            );
          }
        });
        await Promise.all(
          verificationRequests
        ).then(function() {
          navigate(`project/${projectID}`);
        });
    }

    render() {
        if (this.state.project == null) {
            return null
        }

        const { config } = this.context;
        const project = this.state.project;
        const { member_details } = this.state.project;
        const required_flags = [];
        member_details && member_details.forEach(member => {
          const user_needs_flags = needFlags(project, member, config);
          user_needs_flags.uflagsNeeded.forEach(flag => {
            required_flags.push({
              name: member.display_name,
              eppn: member.eppn,
              flag: flag,
              sigline: `I certify that ${member.display_name} (${member.eppn}) satisfies ${flag}`,
              label: member.eppn.replace('.', '-').concat(":" + flag),
              siglabel: member.eppn.replace('.', '-').concat(":" + flag + ":sig"),
              datelabel: member.eppn.replace('.', '-').concat(":" + flag + ":date")
            });
          });
          user_needs_flags.pvflagsNeeded.forEach(flag => {
            required_flags.push({
              name: member.display_name,
              eppn: member.eppn,
              project: project, // how we know it's a verifiable user project flag
              sigline: `I certify that ${member.display_name} (${member.eppn}) satisfies ${flag} for project ${project.id}, "${project.title}"`,
              flag: flag,
              label: member.eppn.replace('.', '-').concat(":" + flag),
              siglabel: member.eppn.replace('.', '-').concat(":" + flag + ":sig"),
              datelabel: member.eppn.replace('.', '-').concat(":" + flag + ":date")
            });
          });
        });

        if (required_flags.length > 0) {
          const boxes = required_flags && required_flags.map((flag, idx) =>
            <div key={idx}>
                <label style={{display: "flex", alignItems: "center", justifyContent: "flex-start", width: "100%"}}>
                  <Checkbox
                    checked={this.state[flag.label] || false}
                    onChange={(e) => {this.handleCheckboxChange(e, flag)}}
                  />
                  <h3 style={{margin: "0 15px 10px"}}>{flag.sigline}</h3>
                </label>
                {this.state[flag.label] && <div>
                  <Field
                    name={flag.siglabel}
                    component="input"
                    validate={sigRequired}
                  >
                    {({ input, meta }) => (
                        <div style={{margin: "0 0 20px"}}>
                                <input {...input} autoComplete="off" type="text" placeholder="Please type your full name" />
                                {meta.error && meta.touched && <span style={ERRORSTYLE}> {meta.error}</span>}
                        </div>
                    )}
                  </Field>
                  <Field
                    name={flag.datelabel}
                    component="input"
                    validate={this.validDate}
                  >
                    {({ input, meta }) => (
                        <div style={{margin: "0 0 20px"}}>
                                <input {...input} autoComplete="off" type="text" placeholder="Completion date (mm/dd/yy)" />
                                {meta.error && meta.touched && <span style={ERRORSTYLE}> {meta.error}</span>}
                        </div>
                    )}
                  </Field>
                </div>}
            </div>);

          return (
            <div style={{padding: "20px"}}>
              <Styles>
                <h1>{project.title}</h1>

                <Form
                    onSubmit={this.onSubmit}
                    render={({handleSubmit, submitting, pristine, invalid }) => (
                        <form onSubmit={handleSubmit} style={{width: "90%"}}>
                            <h2>Please verify that the project members meet the following conditions:</h2>
                            {boxes}
                            <button type="submit" disabled={pristine || invalid || submitting || this.state.verifications.length === 0 }>
                                Submit
                            </button>
                        </form>
                    )}
                />
              </Styles>
            </div>);
        } else {
          return <h2>(No verifications required)</h2>
        }

    }
}
